import { ROUTES } from '../../app/routes';

/** The fields of a webhook call that decide where (and whether) it can be opened. */
export interface WebhookCallLinkFields {
    type: string;
    taskId: number | null;
    routineId: string | null;
    routineRunId: number | null;
    targetAvailable: boolean;
    targetDeleted: boolean;
}

export function isRoutineCall(c: { type: string }): boolean {
    return c.type === 'ROUTINE';
}

/**
 * Command → Command Center task; Routine → that routine (and run, when known).
 * Null when the target was never created or has since been deleted. Commands link by
 * numeric task id — task_transaction_id isn't unique and can resolve to the wrong task.
 */
export function webhookCallLink(c: WebhookCallLinkFields): string | null {
    if (!c.targetAvailable) return null;
    if (isRoutineCall(c)) {
        if (!c.routineId) return null;
        return `${ROUTES.MOMENTUM_ROUTINES}/${encodeURIComponent(c.routineId)}${c.routineRunId != null ? `?runId=${c.routineRunId}` : ''}`;
    }
    if (c.taskId != null) return `${ROUTES.MOMENTUM_COMMAND}/${c.taskId}`;
    return null;
}

/** "Open command" / "Open routine" button label. */
export function webhookCallOpenLabel(c: { type: string }): string {
    return isRoutineCall(c) ? 'Open routine' : 'Open command';
}

/** Why the Open button is disabled, or null when it can be opened. */
export function webhookCallUnavailableReason(c: WebhookCallLinkFields): string | null {
    if (webhookCallLink(c)) return null;
    const kind = isRoutineCall(c) ? 'routine' : 'command';
    return c.targetDeleted
        ? `This ${kind} has been deleted and can no longer be opened.`
        : `This call didn't ${isRoutineCall(c) ? 'start a routine' : 'create a command'}, so there's nothing to open.`;
}
